import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index.tsx";
import ProductPage from "./pages/ProductPage.tsx";
import NotFound from "./pages/NotFound.tsx";
import ResourcesIndex from "./pages/ResourcesIndex.tsx";
import ResourceArticlePage from "./pages/ResourceArticlePage.tsx";

const queryClient = new QueryClient();

// Route tree must stay identical to src/prerender.tsx (no lazy/Suspense), or hydration fails (#418).
const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/products/:slug" element={<ProductPage />} />
          <Route path="/resources" element={<ResourcesIndex />} />
          <Route path="/resources/:slug" element={<ResourceArticlePage />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
